module.exports = __webpack_public_path__ + "img/initial-investment-icon.310ab5ae.svg";